
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|1606|3438|6015|6721|8614|9204)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
